/**
 * Storage conversion utilities for bytes ↔ gigabytes
 */

// 1 GB = 1024 * 1024 * 1024 bytes
export const BYTES_PER_GB = 1024 * 1024 * 1024

/**
 * Convert gigabytes to bytes
 * @param gb Gigabytes value
 * @returns Bytes value
 */
export const gbToBytes = (gb: number): number => {
  return Math.round(gb * BYTES_PER_GB)
}

/**
 * Convert bytes to gigabytes
 * @param bytes Bytes value
 * @returns Gigabytes value
 */
export const bytesToGb = (bytes?: number): number => {
  if (!bytes) return 0
  return Math.round((bytes / BYTES_PER_GB) * 100) / 100 // Round to 2 decimal places
}
